import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SettingsValuesService {

  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  public get FootPrintAPI() {
    return this._SettingsService['FootPrintAPI'];
  }

  public app: SettingsValuesService = this;

  public get IntraOne() {
     return {
FootPrintAPI : this.FootPrintAPI
    };
  }
}
